import { useQuery } from 'react-query';
import { getUserPermissionsAPI, hasPermission } from './api';

const USER_PERMISSIONS = 'userPermissions';

export function useUserPermissions() {
  const { data: permissions, isLoading, isError } = useQuery(
    USER_PERMISSIONS,
    getUserPermissionsAPI,
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 10 * 60 * 1000,
    },
  );

  const checkPermission = (resource, action) => hasPermission(permissions, resource, action);

  return {
    permissions: permissions || {},
    isLoading,
    isError,
    checkPermission,
  };
}
